module.exports = __webpack_public_path__ + "static/media/silverTop1D.75e5a28f.webp";